export default "__VITE_ASSET__CJJ0M7HE__"